import React, {CSSProperties} from 'react'
import styled from 'styled-components'
import {Description as DescriptionText} from 'lib/ui/typography'
import Label from 'lib/ui/TextField/Label'
import MuiSwitch, {
  SwitchProps as MuiSwitchProps,
} from '@material-ui/core/Switch'

export type DescribedSwitchProps = MuiSwitchProps & {
  className?: string
  title?: string
  rightTitle?: string
  description?: string
  fullWidth?: boolean
  boxStyles?: CSSProperties
  titlePosition?: 'top' | 'right'
}

export default function DescribedSwitch(props: DescribedSwitchProps) {
  const {
    className,
    title,
    rightTitle,
    description,
    boxStyles,
    ...switchProps
  } = props

  return (
    <>
      <TopTitle>{title}</TopTitle>
      <Box fullWidth={props.fullWidth} style={boxStyles} className={className}>
        <TopDescription>{description}</TopDescription>
        <SwitchContainer>
          <MuiSwitch {...switchProps} />
          <RightTitle>{rightTitle}</RightTitle>
        </SwitchContainer>
        <RightDescription>{description}</RightDescription>
      </Box>
    </>
  )
}

function TopDescription(props: {children?: string}) {
  if (!props.children) {
    return null
  }
  return (
    <TopDescriptionBox>
      <DescriptionText>{props.children}</DescriptionText>
    </TopDescriptionBox>
  )
}

function RightDescription(props: {children?: string}) {
  if (!props.children) {
    return null
  }

  return (
    <RightDescriptionBox>
      <DescriptionText>{props.children}</DescriptionText>
    </RightDescriptionBox>
  )
}

const SwitchContainer = styled.div`
  max-width: 640px;
  width: 100%;
`

const Box = styled.div<{fullWidth?: boolean}>`
  ${(props) => (props.fullWidth ? 'width: 100%;' : '')}
  margin-bottom: ${(props) => props.theme.spacing[10]};

  @media (min-width: ${(props) => props.theme.breakpoints.md}) {
    display: flex;
    align-items: baseline;
    margin-bottom: ${(props) => props.theme.spacing[5]};
  }
`

const TopDescriptionBox = styled.div`
  padding: 0;
  border: none;
  margin-left: 0;
  margin-bottom: ${(props) => props.theme.spacing[4]} !important;

  @media (min-width: ${(props) => props.theme.breakpoints.md}) {
    display: none;
  }
`

const RightDescriptionBox = styled(TopDescriptionBox)`
  display: none;
  flex: 1 0 40%;
  padding: ${(props) => `${props.theme.spacing[1]} ${props.theme.spacing[7]}`};
  border-left: 1px solid ${(props) => props.theme.colors.primary};
  margin-left: ${(props) => props.theme.spacing[27]};

  @media (min-width: ${(props) => props.theme.breakpoints.md}) {
    display: inline;
  }
`

function TopTitle(props: {children?: string}) {
  if (!props.children) {
    return null
  }

  return <StyledLabel>{props.children}</StyledLabel>
}

function RightTitle(props: {children?: string}) {
  if (!props.children) {
    return null
  }

  return <StyledRightTitle>{props.children}</StyledRightTitle>
}

const StyledRightTitle = styled.div`
  display: inline;
`

const StyledLabel = styled(Label)`
  margin-bottom: ${(props) => props.theme.spacing[4]} !important;

  @media (min-width: ${(props) => props.theme.breakpoints.md}) {
    display: none;
  }
`
